// https://help.klaviyo.com/hc/en-us/articles/115005076767 */

import React from "react";
import { Helmet } from "react-helmet";

const KlaviyoScripts = () => {
  const PUBLIC_API_KEY = `W8d6Q7`;

  return (
    <Helmet>
      {/* Onsite Tracking & Forms */}
      <script
        type="text/javascript"
        async=""
        src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${PUBLIC_API_KEY}`}
      />

      {/* Viewed Product */}
      {/* On PDP */}

      {/* Added to Cart */}
      <script>
        {`
          window.addEventListener('load', function() {
          var _learnq = window._learnq || [];
          function addedToCart() {
            fetch(window.location.origin + "/cart.js"
            )
            .then(res => res.clone().json().then(data => {
              var cart = {
                total_price: data.total_price/100,
                $value: data.total_price/100,
                total_discount: data.total_discount,
                original_total_price: data.original_total_price/100,
                items: data.items
              }
              if (item !== 'undefined') {
                cart = Object.assign(cart, item)
              }
              if (klAjax) {
                  _learnq.push(['track', 'Added to Cart', cart]);
                  klAjax = false;
                }
            }))
          };
          (function (ns, fetch) {
            ns.fetch = function() {
              const response = fetch.apply(this, arguments);
              response.then(res => {
                if (window.location.origin + "/cart/add.js"

                  .includes(res.url)) {
                    addedToCart()
                }
              });
              return response
            }
          }(window, window.fetch));
          var klAjax = true;
          var atcButtons = document.querySelectorAll(".add-to-cart-button-lgf");
          for (var i = 0; i < atcButtons.length; i++) {
              atcButtons[i].addEventListener("click", function() {
                if (klAjax) {
                  _learnq.push(['track', 'Added to Cart', item]);
                  klAjax = false;
                }
              })
          }
          });
        `}
      </script>

      <script type="text/javascript">
        {`
          (function () {
            if (!window || !window.Shopify) return;

            const CartEvents = {
              add: "SCE:add",
              update: "SCE:update",
              change: "SCE:change",
              clear: "SCE:clear",
              mutate: "SCE:mutate",
            };

            const ShopifyCartURLs = [
              "/cart/add",
              "/cart/update",
              "/cart/change",
              "/cart/clear",
              "/cart/add.js",
              "/cart/update.js",
              "/cart/change.js",
              "/cart/clear.js",
            ];

            function isShopifyCartURL(url) {
              if (!url) return false;
              const path = url.split("/").pop();
              return ShopifyCartURLs.includes("/cart/" + path);
            }

            function updateType(url) {
              if (!url) return false;
              if (url.includes("cart/add")) {
                return "add";
              } else if (url.includes("cart/update")) {
                return "update";
              } else if (url.includes("cart/change")) {
                return "change";
              } else if (url.includes("cart/clear")) {
                return "clear";
              } else return false;
            }

            function dispatchEvent(url, detail) {
              if (typeof detail === "string") {
                try {
                  detail = JSON.parse(detail);
                } catch {}
              }

              window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
              const type = updateType(url);
              switch (type) {
                case "add":
                  window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
                  break;
                case "update":
                  window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
                  break;
                case "change":
                  window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
                  break;
                case "clear":
                  window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
                  break;
                default:
                  break;
              }
            }

            function XHROverride() {
              if (!window.XMLHttpRequest) return;

              const originalOpen = window.XMLHttpRequest.prototype.open;
              window.XMLHttpRequest.prototype.open = function () {
                const url = arguments[1];
                this.addEventListener("load", function () {
                  if (isShopifyCartURL(url)) {
                    dispatchEvent(url, this.response);
                  }
                });
                return originalOpen.apply(this, arguments);
              };
            }

            function fetchOverride() {
              if (!window.fetch || typeof window.fetch !== "function") return;
              const originalFetch = window.fetch;
              window.fetch = function () {
                const response = originalFetch.apply(this, arguments);

                if (isShopifyCartURL(arguments[0])) {
                  response.then((res) => {
                    res
                      .clone()
                      .json()
                      .then((data) => dispatchEvent(res.url, data));
                  });
                }

                return response;
              };
            }

            fetchOverride();
            XHROverride();
          })();

          window.addEventListener('SCE:add', (event) => {
            const object = event.detail;
            const siteUrl = "{{shop.url}}";
            const pageUrl = window.location.href;
            
            if(object.items) {
              var product = object.items[0];
            } else {
              var product = object;
            }

            _learnq.push(["track", "Added to Cart",{
              $value: product.price/100,
              "Brand": product.vendor,
              "ProductName": product.product_title,
              "ProductPrice": product.price/100,
              "ProductID": product.id,
              "ProductImageURL": product.image,
              "ProductURL": siteUrl + product.url,
              "PageURL": pageUrl
            }]);
            
          })
        `}
      </script>

      {/* Viewed Form Tracked Profile & Submitted Form Tracked Profile */}
      <script>
        {`
          var _learnq = window._learnq || [];
          window.addEventListener("klaviyoForms", function(e) { 
            if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
              _learnq.push(['track', 'Viewed Form - Tracked Profile', {
                'formId' : e.detail.formId
              }]);
            }
            if (e.detail.type == 'submit') {
              _learnq.push(['track', 'Submitted Form - Tracked Profile', {
              'formId' : e.detail.formId
            }]);
            }
          });
        `}
      </script>

      {/* Viewed Page */}
      <script>
        {`
          var _learnq = _learnq || []; 
          var page = window.location.href;
          _learnq.push(['track', 'Viewed Page',
          {url: page}
          ]);
        `}
      </script>

      {/* Viewed Category */}
      <script type="text/javascript">
        {`
          var _learnq = _learnq || [];
          _learnq.push(["track", "Viewed Collection",{
            "CategoryName": "{{collection.title}}",
            "CategoryID": "{{collection.id}}",
            "CategoryImage": "https:" + "{{ collection.image | img_url }}",
            "CategoryUrl": document.location.href
          }]);
        `}
      </script>

      {/* Searched Site */}
      <script type="text/javascript">
        {`
          var _learnq = _learnq || [];
          _learnq.push(["track", "Searched Site",{
            "SearchTerm": "{{search.terms}}",
            "ReturnedResults": "{{search.results_count|json}}"
          }]);
        `}
      </script>

      {/* Referral URL */}
      <script type="text/javascript">
        {`
          var siteUrl = document.location.host;
          var referralUrl = document.referrer;
          var pageVisited = document.location.href;

          var params = new URL(document.location).searchParams;
          var utm_source = params.get("utm_source");
          var utm_medium = params.get("utm_medium");
          var utm_campaign = params.get("utm_campaign");

          if(referralUrl === "") {
            if(utm_medium) {
              var referrer = utm_medium
            } else {
              var referrer = "Direct"
            }
            
          } else {
            var referrer = referralUrl
          }
          
          if (referralUrl.indexOf(siteUrl) === -1) {
            _learnq.push(["track", "Referral URL",{
              "Referrer": referrer,
              "PageVisited": pageVisited,
              "UtmSource": utm_source,
              "UtmMedium": utm_medium,
              "UtmCampaign": utm_campaign
            }]);
          }
        `}
      </script>

      {/* Back In Stock for Shopify */}
      {/* Can't do on custom themes */}
    </Helmet>
  );
};

export default KlaviyoScripts;
